import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useCompanyMutationsQuery } from 'hooks/api'

import { Stack, Typography } from '@mui/material'

import { Modal } from '@repo/ui'
import { Button } from '@repo/ui'



interface UnsuspendCompanyModalProps {
  company: any
  open: boolean
  onClose: () => void
  refetch: () => void
}

export const UnsuspendCompanyModal = (props: UnsuspendCompanyModalProps) => {
  const { company, open, onClose = () => {}, refetch } = props

  const { open: notification } = useSnackbar()

  const { unsuspend, isLoading } = useCompanyMutationsQuery({
    onSuccess: () => {
      handleClose()
      refetch()
    },
    onError: error => {
      const message = getErrorMessage(error)
      notification({
        type: 'error',
        title: message,
      })
    },
  })

  const handleUnsuspendCompany = () => {
    if (!company?.id) return
    unsuspend({ companyId: company.id })
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      title="Unsuspend company"
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button
            disableElevation
            variant="secondary"
            onClick={() => handleClose()}
            disabled={isLoading}
          >
            Cancel
          </Button>

          <Button
            disableElevation
            onClick={() => handleUnsuspendCompany()}
            disabled={isLoading}
          >
            {isLoading ? 'Unsuspending...' : 'Unsuspend'}
          </Button>
        </>
      }
    >
      <Stack spacing="16px">
        <Typography variant="body2" color="text.secondary">{`Are you sure you want to unsuspend "${company?.name}"? This will restore their access.`}</Typography>
      </Stack>
    </Modal>
  )
}
